/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Camera_UnconfiguredInputs */

const vi_grower_area_camera_unconfigured = /** @type {(inputs: Grower_Area_Camera_UnconfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa cấu hình`)
};

/**

* @param {Grower_Area_Camera_UnconfiguredInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_camera_unconfigured = /** @type {((inputs?: Grower_Area_Camera_UnconfiguredInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Camera_UnconfiguredInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_camera_unconfigured(inputs)
});